var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      { staticStyle: { "min-height": "200px" }, attrs: { id: "payment-form" } },
      [
        _c("div", { attrs: { id: "payment-element" } }),
        _vm._v(" "),
        _c("div", { attrs: { id: "error-message" } }),
        _vm._v(" "),
        _vm.elementsLoading
          ? _c(
              "div",
              {
                staticClass: "flex justify-center align-center",
                staticStyle: { height: "200px" },
              },
              [
                _c("v-progress-circular", {
                  attrs: { indeterminate: "", color: "primary" },
                }),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }